(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2107],{

/***/ 67398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BsClock; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function BsClock(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 33012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./common/action-function/scrollToElement.js
var scrollToElement = __webpack_require__(97974);
// EXTERNAL MODULE: ./common/functions.js
var functions = __webpack_require__(98989);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/CheckContent/index.js
var CheckContent = __webpack_require__(36484);
// EXTERNAL MODULE: ./components/atoms/Icon/bs/BsClock.js
var BsClock = __webpack_require__(67398);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/FormDowload/index.js
var FormDowload = __webpack_require__(73765);
// EXTERNAL MODULE: ./components/organisms/WhatMakeUsDifferent/WhatMakeUsDifferentV3.js + 2 modules
var WhatMakeUsDifferentV3 = __webpack_require__(97542);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/hk/guide-and-tool/hong-kong-ecommerce-guide/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var HongKongEcommerceGuide = function HongKongEcommerceGuide(_ref) {
  var _firstPost$featuredIm;

  var data = _ref.data,
      posts = _ref.posts;
  var firstPost = posts[0] || {};
  var listPost = posts.length > 1 ? posts.filter(function (item, index) {
    return index > 0 && index < 6;
  }) : [];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: "banner-min-h-569",
      title: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: "mb-4 text-center text-bbc-40px font-semibold text-bbc-brand-600 lg:mb-2 lg:text-left lg:text-bbc-48px",
        dangerouslySetInnerHTML: {
          __html: data.banner.title
        }
      }),
      description: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-4 text-center lg:mb-6 lg:text-left",
        dangerouslySetInnerHTML: {
          __html: data.banner.description
        }
      }),
      tag: data.banner.tag,
      breadcrumbs: data.banner.breadcrumbs,
      breadcrumbMarginClass: "mb-6",
      bgColor: "bg-bbc-gradient-hk-ecommerce",
      titleProps: {
        textColor: "text-bbc-brand-600"
      },
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        wrapper: {
          className: "bbc-banner-image-country xl:top-24"
        },
        src: data.banner.image,
        width: 540,
        height: 459,
        priority: true,
        alt: "banner-img"
      }),
      leftClassName: "relative col-12 lg:col-7",
      leftContent: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6 text-center lg:mb-0 lg:pb-10 lg:text-left xl:pb-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
          href: "#".concat(data.dataFormDownload.id),
          as: "a",
          className: "",
          onClick: function onClick(e) {
            (0,scrollToElement/* default */.Z)(e, false);
          },
          children: "Download now"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mt-10 lg:mt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "With this guide, you'll be able to",
          className: "title-h2 mb-6 text-center text-bbc-brand-700 lg:mb-10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden lg:block",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "row",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12 lg:col-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, _objectSpread({
                width: 540,
                height: 540,
                alt: "section-1-image"
              }, data.ebookImage))
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12 lg:col-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Tab.Group */.OK.Group, {
                as: "div",
                className: "mt-6",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.List */.OK.List, {
                  className: "flex gap-x-4",
                  children: data.dataWhatMakeUsDifferent.map(function (item, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab */.OK, {
                      className: "relative mb-6",
                      children: function children(_ref2) {
                        var selected = _ref2.selected;
                        return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: "inline-block px-1 py-2 text-lg font-medium ".concat(selected ? "text-bbc-brand-600 before:absolute before:bottom-0 before:left-0 before:h-0.5 before:w-full before:bg-bbc-brand-600 before:content-['']" : "text-bbc-neutral-600"),
                          children: item.title
                        });
                      }
                    }, index);
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
                  children: data.dataWhatMakeUsDifferent.map(function (item, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panel */.OK.Panel, {
                      children: item.description.map(function (element, i) {
                        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                          children: [element.content && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                            className: "mb-2 font-medium",
                            children: element.text
                          }), element.listWithIcon && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                            className: "pl-2",
                            children: element.listWithIcon.map(function (e, number) {
                              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                                className: "mb-2",
                                children: /*#__PURE__*/(0,jsx_runtime.jsx)(CheckContent/* default */.Z, {
                                  data: e
                                })
                              }, number);
                            })
                          })]
                        }, i);
                      })
                    }, index);
                  })
                })]
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhatMakeUsDifferentV3/* WhatMakeUsDifferentV3 */.N, {
          data: data.dataWhatMakeUsDifferent,
          ebookImage: data.ebookImage,
          className: "lg:hidden"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "Browse the latest insights",
          className: "title-h2 mb-6 text-center text-bbc-brand-700"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-6 text-center lg:mb-10",
          children: "Get the facts you need on various topics of Hong Kong E-commerce to make the right decisions."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 lg:col-8",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "overflow-hidden rounded-[20px] bg-bbc-neutral-200 hover:shadow-[0px_0px_20px_rgba(124,120,120,0.2)]",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                image: firstPost === null || firstPost === void 0 ? void 0 : (_firstPost$featuredIm = firstPost.featuredImage) === null || _firstPost$featuredIm === void 0 ? void 0 : _firstPost$featuredIm.node
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "p-6 lg:px-10 lg:pb-10 lg:pt-8",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  as: "h3",
                  className: "text-lg font-semibold text-bbc-brand-900 lg:text-bbc-30px",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                    href: firstPost === null || firstPost === void 0 ? void 0 : firstPost.uri,
                    children: firstPost === null || firstPost === void 0 ? void 0 : firstPost.title
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "mt-6 inline-flex items-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BsClock/* BsClock */.Z, {
                    size: 18
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "inline-block pl-2 text-sm",
                    children: (0,functions/* formatDate */.p)(firstPost === null || firstPost === void 0 ? void 0 : firstPost.date)
                  })]
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 lg:col-4",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "row mt-6 gap-y-3 lg:mt-0",
              children: listPost.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-12",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "p-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                      as: "h3",
                      className: "text-lg font-medium line-clamp-3",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                        href: item === null || item === void 0 ? void 0 : item.uri,
                        children: item === null || item === void 0 ? void 0 : item.title
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "mt-3 inline-flex items-center",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BsClock/* BsClock */.Z, {
                        size: 18
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "inline-block pl-2 text-sm",
                        children: (0,functions/* formatDate */.p)(item === null || item === void 0 ? void 0 : item.date)
                      })]
                    })]
                  })
                }, index);
              })
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      id: data.dataFormDownload.id,
      className: "bg-bbc-gradient-service py-10 lg:py-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormDowload/* default */.Z, {
          title: data.dataFormDownload.title || "",
          description: data.dataFormDownload.description || "",
          checkboxText: data.dataFormDownload.checkboxText || "",
          checkboxTextClassName: data.dataFormDownload.checkboxTextClassName || "",
          apiLink: data.dataFormDownload.form.apiLink,
          checkedId: data.dataFormDownload.form.checkedId,
          unCheckId: data.dataFormDownload.form.unCheckId,
          countryId: data.dataFormDownload.form.countryId
        })
      })
    })]
  });
};

/* harmony default export */ var hong_kong_ecommerce_guide = (HongKongEcommerceGuide);
;// CONCATENATED MODULE: ./pages/hk/guide-and-tool/hong-kong-ecommerce-guide/data.json
var data_namespaceObject = JSON.parse('{"banner":{"title":"Hong Kong <span class=\'whitespace-nowrap\'>E-commerce</span> Guideline","description":"This guide helps you make sense of the <span class=\'whitespace-nowrap\'>E-commerce</span> landscape in Hong Kong - start, run, and manage your online business with ease.","tag":"Free download","image":"/assets/images/hk/guide-and-tool/hong-kong-ecommerce-guide/banner-hk-ecommerce.png","breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Guide & Tool","uri":"/guide-and-tool"},{"title":"Hong Kong <span class=\'whitespace-nowrap\'>E-commerce</span> Guide"}]},"ebookImage":{"src":"/assets/images/hk/guide-and-tool/hong-kong-ecommerce-guide/ebook-hk-ecommerce.png","width":540,"height":540},"dataWhatMakeUsDifferent":[{"title":"Pre-incorporation","description":[{"content":"Lay your groundwork for success by understanding the key essentials:","listWithIcon":["Choose the right products","Reach your targeted customers","Understand your business model","Figure out your fulfilment methods"]}]},{"title":"Incorporation","description":[{"content":"Start a successful E-commerce business you can be proud of in 4 simple steps:","listWithIcon":["Choose entity structure","Pick a company name","Set up company governance","File incorporation document"]}]},{"title":"Post-incorporation","description":[{"content":"Get to grips with all aspects of legal compliance for E-commerce business in Hong Kong:","listWithIcon":["Annual filings and maintenance","Tax returns","Accounting and Auditing","Bank account opening"]}]}],"dataFormDownload":{"id":"hong-kong-ecommerce-guide","title":"Ready to turn your <span class=\'whitespace-nowrap\'>E-commerce</span> idea into reality?","description":"Fill out the form to access your all-inclusive Hong Kong <span class=\'whitespace-nowrap\'>E-commerce</span> guide.","checkboxText":"Get email updates from BBCIncorp about news, offers, and events related to Hong Kong E-commerce. We\'re committed to your privacy and we will never sell, rent or spam your email. For more information, review our <a href=\'/hk/privacy-policy\' class=\\"text-bbc-primary\\" target=\'_blank\'>Privacy Policy</a> and <a href=\'/hk/terms-of-services\' class=\\"text-bbc-primary\\" target=\'_blank\'>Terms of Services</a>.","checkboxTextClassName":"text-sm leading-6","form":{"apiLink":"api/portal/contact_form/ecommerce_guide","triggerName":"RMD - Ecommerce guide - HK","checkedId":41,"unCheckId":42,"countryId":98}}}');
;// CONCATENATED MODULE: ./pages/hk/guide-and-tool/hong-kong-ecommerce-guide/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "hk",
      page: data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(hong_kong_ecommerce_guide, {
        data: data_namespaceObject,
        posts: data.posts
      })
    })
  });
}

/***/ }),

/***/ 78313:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hk/guide-and-tool/hong-kong-ecommerce-guide",
      function () {
        return __webpack_require__(33012);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,8352,9413,4090,9738,7447,7720,2888,179], function() { return __webpack_exec__(78313); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);